import * as type from "../types";

export function putCSVFileInBlob(payload) {
    return {
        type: type.PUT_CSV_FILE_IN_BLOB,
        payload: payload,
      };
}

export function postOTPToUser(payload){
  return {
    type: type.POST_OTP_TO_USER,
    payload: payload,
  };
}

export function verifyOTPWithUser(payload){
  return {
    type: type.VERIFY_OTP_WITH_USER,
    payload: payload,
  };
}

export function closeOTPModal(){
  return {
    type: type.CLOSE_OTP_MODAL,
  };
}

export function getFilesData(payload){
  return {
    type: type.GET_FILES_DATA,
    payload: payload,
  };
}

export function updateScheduleCallTimeAction(payload){
  return {
    type: type.UPDATE_SCHEDULE_CALL_TIME,
    payload: payload,
  };
}

export function updateStopCallAction(payload){
  return {
    type: type.UPDATE_STOP_CALL,
    payload: payload,
  };
}

export function disableFileAction(payload){
  return {
    type: type.DISABLE_FILE,
    payload: payload,
  };
}

export function setModalForStopCallAction(payload){
  return {
    type: type.SET_MODAL_STOP_CALL,
    payload: payload,
  };
}

export function downloadBlobFile(payload){
  return {
    type: type.DOWNLOAD_BLOB_FILE,
    payload: payload,
  };
}

export function stopCurrentCallAction(){
  return {
    type: type.STOP_CURRENT_CALL,
  };
}

export function fetchGlobalConfigsAction(payload){
  return {
    type: type.FETCH_GLOBAL_CONFIG,
    payload: payload,
  };
}

export function updateGlobalConfigsAction(payload){
  return {
    type: type.UPDATE_GLOBAL_CONFIG,
    payload: payload,
  };
}